/**
 * Where "Publish with Postly" sends the streamer.
 *
 * Postly is a third-party multi-platform scheduler (Merchant-of-Record and all
 * the platform OAuth is theirs, not ours). This is a plain referral: the clips
 * are downloaded here and uploaded there, which keeps us out of the brittle
 * business of maintaining TikTok/Instagram/YouTube publishing APIs.
 *
 * Drop your own referral link in here to earn affiliate credit — append your
 * ref, e.g. "https://www.postly.ai/?ref=YOUR_CODE". Left as the plain site, the
 * button still works; it just earns nothing.
 */
export const POSTLY_URL = "https://www.postly.ai/";
